export default {
  calculateDiscount(cost: number, discountMultiplier: number): number {
    const discount = cost * discountMultiplier;

    return Math.floor(this.correctFloatNumber(discount * 100)) / 100;
  },
  correctFloatNumber(floatNumber: number, fraction: number = 2): number {
    const multiplier = 10 ** fraction;

    return Math.round(floatNumber * multiplier) / multiplier;
  },
};
